/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import parse from 'html-react-parser';

import LocalStorageService from '~services/LocalStorageService';
import CartActions from '~redux/Cart/actions';
import SearchStoreActions from '~redux/SearchStore/actions';
import { CLIENT_PAGES } from '~constants/pages';
import AuthenticatedRoute from '~components/Routes/components/AuthenticatedRoute';
import useCheckScheduledOrder from '~hooks/useCheckScheduledOrder';
import { useAuth } from '~hooks/useAuth';
import { useRegisterCartChanges } from '~hooks/useRegisterCartChanges';
import { useRestoreCart } from '~hooks/useRestoreCart';
import ChatButtons from '~app/components/ChatButtons';
import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';

import styles from './styles.module.scss';
import CloseSessionModal from './components/CloseSessionModal';
import ProfileMenuModal from './components/Navbar/components/ProfileMenu/components/ProfileMenuModal';
import MiniCartModal from './components/Navbar/components/Minicart/components/MiniCartModal';
import ChangeAddressModal from './components/ChangeAddress';
import LoginModal from './components/LoginModal';
import ClosedStoreModal from './components/ClosedStoreModal';
import {
  Home,
  Checkout,
  Orders,
  PurchaseSuccess,
  PurchaseFailure,
  ProcessingPurchase,
  ProcessingAddCard,
  TermsAndConditions,
  MercatTermsAndConditions,
  Profile,
  AddCardSuccess,
  AddCardFailure,
  NPS
} from './constants';
import UnavailableProducts from './components/UnavailableProducts';
import ErrorCheckCartModal from './components/ErrorCheckCartModal';
import FutureOrderModal from './components/FutureOrderModal';
import NoRidersModal from './components/NoRidersModal';
import PickCommuneModal from './components/PickCommuneModal';
import useCommerceQueryParams from './hooks/useCommerceQueryParams';
import SmartbannerContext from './contexts/SmartbannerContext/context';
import ForbiddenModal from './components/ForbiddenModal';

function Commerce() {
  useAuth();
  const dispatch = useDispatch();
  const isCheckout = !!useRouteMatch(CLIENT_PAGES.CHECKOUT.basePath);
  const { commerceName: homeTitle, appsLinks } = useSelector((state) => state.core.settings);
  const { currentSubsidiary, dispatchType } = useSelector((state) => state.searchStore);
  const defaultStoreId = useSelector((state) => state.core.defaultStoreId);
  const { pages } = useSelector((state) => state.pages);
  const [store, dispatchMethod] = useCommerceQueryParams();
  const localStorageCart = LocalStorageService.getCart();
  const [isSmartbannerActive, setIsSmartbannerActive] = useState(false);
  const forbiddenModalIsOpen = Boolean(useSelector((state) => state.modal[`${MODALS.FORBIDDEN}ModalIsOpen`]));
  const plus18 = useSelector((state) => state.core.settings.over18Restriction);
  const alreadyAnswered = LocalStorageService.getPlus18();

  useEffect(() => {
    if (plus18 && !alreadyAnswered) {
      dispatch(ModalActions.openModal(MODALS.FORBIDDEN));
    }
  }, [alreadyAnswered, plus18]);

  useEffect(() => {
    dispatch(CartActions.setCart(localStorageCart || []));
    dispatch(CartActions.setSubtotalPrice(LocalStorageService.getFinalPrice() || 0));
    dispatch(
      SearchStoreActions.getStoreData(
        store || currentSubsidiary?.id || defaultStoreId,
        dispatchMethod || dispatchType,
        store ? null : currentSubsidiary
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, store, dispatchMethod]);
  useCheckScheduledOrder();
  useRegisterCartChanges();
  useRestoreCart();

  useEffect(() => dispatch(SearchStoreActions.getAllStores()), []);

  const pageRender = (page) => () => (
    <html className={styles.containerHtml}>
      <div className={styles.containerTitle}>{page.title}</div>
      <div className={styles.container}>{parse(page.content)}</div>
    </html>
  );
  return (
    <>
      <SmartbannerContext.Provider
        value={{
          isSmartbannerActive: isSmartbannerActive,
          setIsSmartbannerActive: setIsSmartbannerActive
        }}>
        <Switch>
          {pages.page?.map((page) => (
            <AuthenticatedRoute
              key={page.relativeUrl}
              exact
              path={page.relativeUrl}
              component={pageRender(page)}
            />
          ))}
          <AuthenticatedRoute {...CLIENT_PAGES.PROFILE} component={Profile} />
          <AuthenticatedRoute {...CLIENT_PAGES.TERMS_AND_CONDITIONS} component={TermsAndConditions} />
          <AuthenticatedRoute
            {...CLIENT_PAGES.MERCAT_TERMS_AND_CONDITIONS}
            component={MercatTermsAndConditions}
          />
          <AuthenticatedRoute {...CLIENT_PAGES.ORDERS} component={Orders} />
          <AuthenticatedRoute {...CLIENT_PAGES.PURCHASE_SUCCESS} component={PurchaseSuccess} />
          <AuthenticatedRoute {...CLIENT_PAGES.PURCHASE_FAILURE} component={PurchaseFailure} />
          <AuthenticatedRoute {...CLIENT_PAGES.PROCESSING_PURCHASE} component={ProcessingPurchase} />
          <AuthenticatedRoute {...CLIENT_PAGES.PROCESSING_ADD_CARD} component={ProcessingAddCard} />
          <AuthenticatedRoute {...CLIENT_PAGES.ADD_CARD_SUCCESS} component={AddCardSuccess} />
          <AuthenticatedRoute {...CLIENT_PAGES.ADD_CARD_FAILURE} component={AddCardFailure} />
          <AuthenticatedRoute {...CLIENT_PAGES.NPS} title={homeTitle} component={NPS} />
          <AuthenticatedRoute {...CLIENT_PAGES.CHECKOUT} component={Checkout} />
          <AuthenticatedRoute
            {...CLIENT_PAGES.HOME}
            title={homeTitle}
            description={homeTitle}
            component={Home}
            appsLinks={appsLinks}
          />
        </Switch>
      </SmartbannerContext.Provider>
      <ChatButtons />
      {forbiddenModalIsOpen ? (
        <ForbiddenModal isOpen={forbiddenModalIsOpen} />
      ) : (
        <>
          <ProfileMenuModal />
          <MiniCartModal />
          <LoginModal />
          <CloseSessionModal />
          <ClosedStoreModal />
          <NoRidersModal />
          <UnavailableProducts />
          <ErrorCheckCartModal />
          <PickCommuneModal />
          <ChangeAddressModal hideCloseButton={isCheckout} />
          {currentSubsidiary && <FutureOrderModal />}
        </>
      )}
    </>
  );
}

export default Commerce;
